import { StepLabel } from '@mui/material';
import styled from 'styled-components';

export const CustomStepLabel = styled(StepLabel)`
  .MuiStepLabel-label {
    color: ${({ active, completed }) => (active || completed ? '#8CB4C7' : '#A2A6AC')};

    &.Mui-active {
      color: #8cb4c7;
    }

    &.Mui-completed {
      color: #8cb4c7;
    }
  }
`;

export const SectionTitle = styled('h3')`
  font-size: 16px;
  color: #333;
  font-weight: 500;
  text-align: left;
  max-width: 700px;
`;
